import React from 'react'
import { Col, Row } from 'reactstrap'

const PathogenWeeklyRates = () => {
  return (
    <div id='website-responsive'>
        <div className='left-padding6rem1 right-padding6rem1 py-md-5 py-4 '>
            <div className='pb-4'>
                <div className='fs-ss-30-2 text-montserrat text-ss-primary fw-700 lh-1-2 pb-2 flex-center'>
                    Weekly Detection Rates
                </div>
                <div className='flex-center'>
                    <hr className='hr-style my-md-' style={{ width:'80px', marginTop:'2px', marginBottom:'4px'}}/>
                </div>
            </div>

            <div className='left-padding6rem0 right-padding6rem0 py-md-4 py-4'>
                <Row className=''>
                    <Col md='7' className=''>
                        <div className='mb-md-0 mb-4'>
                            <img src='pathogen-testing/Respiratory-Pathogen-Panel-Testing-stats1.1.png' alt='pathogen-testing' className='' height='' width='103%' />
                        </div>
                    </Col>
                    <Col xs='12' md='5' className=''>
                        <div className='flex-center'>
                            <img src='pathogen-testing/Respiratory-Pathogen-Panel-Testing-stats1.2.png' alt='pa' className='' height='' width='58%' />
                        </div>
                    </Col>
                </Row>
            </div>

            <div className='left-padding6rem0 right-padding6rem0 py-2'>
                <div className='flex-center'>
                <img src='pathogen-testing/Respiratory-Pathogen-Panel-Testing-stats1.3-1024x358.png' alt='pa' className='img-w8' height='' width=''  />
                </div>
            </div>

            <div className='py-4'>
                <div className='fs-ss-22-2 text-montserrat text-ss-primary fw-700 lh-1-2 pb-2 flex-center'>
                    High Activity {'(>3%)'}
                </div>
                <div className='flex-center'>
                    <hr className='hr-style my-md-' style={{ width:'80px', marginTop:'2px', marginBottom:'4px'}}/>
                </div>
            </div>

            <div className='pt-4'>
                <Row className='pb-md-4 pb-3'>
                    <Col xs='12' md='4' lg='' className='my-4 my-md-0'>
                        <div className='flex-center'>
                            <img src='pathogen-testing/Respiratory-Pathogen-Panel-Testing-stats2.1.png' alt='pa' className='img-w6' height='' width=''  />
                        </div>
                    </Col>
                    <Col xs='12' md='4' lg='' className='my-4 my-md-0'>
                        <div className='flex-center'>
                            <img src='pathogen-testing/Respiratory-Pathogen-Panel-Testing-stats2.4.png' alt='pa' className='img-w6' height='' width=''  />
                        </div>
                    </Col>
                    <Col xs='12' md='4' lg='' className='my-4 my-md-0'>
                        <div className='flex-center'>
                            <img src='pathogen-testing/Influenza-Testing-stats2.1.png' alt='pa' className='img-w6' height='' width=''  />
                        </div>
                    </Col>
                </Row>

                <Row className='pt-md-5'>
                    <Col xs='12' md='4' lg='' className='my-4 my-md-0'>
                        <div className='flex-center'>
                            <img src='pathogen-testing/Respiratory-Pathogen-Panel-Testing-stats2.2.png' alt='pa' className='img-w6' height='' width=''  />
                        </div>
                    </Col>
                    <Col xs='12' md='4' lg='' className='my-4 my-md-0'>
                        <div className='flex-center'>
                            <img src='pathogen-testing/Influenza-Testing-stats2.2.png' alt='pa' className='img-w6' height='' width=''  />
                        </div>
                    </Col>
                    <Col xs='12' md='4' lg='' className='my-4 my-md-0'>
                        <div className='flex-center'>
                            <img src='pathogen-testing/Respiratory-Pathogen-Panel-Testing-stats2.3.png' alt='pa' className='img-w6' height='' width=''  />
                        </div>
                    </Col>
                </Row>
            </div>

            <div className='py-4'>
                <div className='fs-ss-22-2 text-montserrat text-ss-primary fw-700 lh-1-2 pb-2 flex-center'>
                    Medium Activity (1%-3%)
                </div>
                <div className='flex-center'>
                    <hr className='hr-style my-md-' style={{ width:'80px', marginTop:'2px', marginBottom:'4px'}}/>
                </div>
            </div>

            <div className='pt-4'>
                <Row className='pb-md-4 pb-3 d-flex justify-content-center'>
                    <Col xs='12' md='5' lg='' className='my-4 my-md-0'>
                        <div className='flex-center'>
                            <img src='pathogen-testing/Influenza-Testing-stats2.3.png' alt='pa' className='img-w6' height='' width=''  />
                        </div>
                    </Col>
                    <Col xs='12' md='5' lg='' className='my-4 my-md-0'>
                        <div className='flex-center'>
                            <img src='pathogen-testing/Influenza-Testing-stats2.4.png' alt='pa' className='img-w6' height='' width=''  />
                        </div>
                    </Col>
                </Row>
        </div>
        </div>
    </div>
  )
}

export default PathogenWeeklyRates